const Service = {

    // FIELDS
    "name": "Name",
    "image": "Image",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    "sub_category": "Sub Category",
    "hour": "Hour",
    "minute": "Minute",

    // PAGE HEADER
    "service": "Service",

    // ERROR
    "error_name": "Enter Name",
    "error_image": "Select Image",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_sub_category": "Select Sub Category",
    "error_category": "Select Category",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_image": "IMAGE",
    "table_description": "DESCRIPTION",
    "table_sub_category": "SUB CATEGORY",
    "table_duration": "DURATION",
    "table_status": "STATUS",

    // OTHER
    "current_image": "Current Image",

}

export default Service;

